import { combineReducers } from 'redux';
import nav from './nav.js';
import orderHist from './orderHist.js';
import prodOrderHist from './prodOrderHist.js';
import planning from './planning.js';

const rootReducer = combineReducers({
  nav,
  orderHist,
  prodOrderHist,
  planning
});

export default rootReducer;